import deepmerge from 'deepmerge'
import { ACTION_TYPES } from '~/core/constants'

const { SHARED_FILES } = ACTION_TYPES
const initialState = {
  map: {}
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SHARED_FILES.FETCHING_IN_PROGRESS: {
      return {
        ...state,
        map: deepmerge(state.map, {
          [action.payload.sessionId]: {
            fetchingInProgress: action.payload.value
          }
        })
      }
    }
    case SHARED_FILES.FETCHED_SHARED_FILES: {
      return {
        ...state,
        map: deepmerge(state.map, action.payload)
      }
    }
    case SHARED_FILES.PURGE_SHARED_FILES_DATA: {
      const updatedMap = { ...state.map }
      delete updatedMap[action.payload.sessionId]

      return {
        ...state,
        map: updatedMap
      }
    }
    default:
      return state
  }
}

export default reducer
